function CitiesCloseBtn(props) {
    return (
        <div onClick={props.closeMenu} class='country-item__cities-close'>
            <svg version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                x="0px" y="0px" viewBox="0 0 120 120" >
                <g id="Layer_1">
                    <rect class="st0" width="120" height="120" />
                </g>
                <g id="Layer_2">
                    <g>
                        <g>
                            <line class="st1" x1="10" y1="110" x2="110" y2="10" />
                            <rect x="58.5" y="-10.7" transform="matrix(0.7071 0.7071 -0.7071 0.7071 60 -24.8528)" class="st1" width="3" height="141.4" />
                        </g>
                        <g>
                            <line class="st1" x1="10" y1="10" x2="110" y2="110" />
                            <rect x="-10.7" y="58.5" transform="matrix(0.7071 0.7071 -0.7071 0.7071 60 -24.8528)" class="st1" width="141.4" height="3" />
                        </g>
                    </g>
                </g>
            </svg>
        </div>
    )
}

export default CitiesCloseBtn